import { kingItems } from '@/mocks/home';

export default function KingBoard() {
  const [top, rest] = [kingItems.slice(0, 3), kingItems.slice(3)];

  return (
    <section id="king" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-24">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">2026 · 年度瓜王</p>
          <h2 className="font-heading text-2xl font-black tracking-tight md:text-4xl">谁是今年最能打的「瓜」</h2>
          <p className="max-w-2xl text-sm text-foreground-700 md:text-base">
            三轮围观投票 × 全网热度加权，综合「发酵快、影响大、反转多」三档指标，评出年度瓜王。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {top.map((k, i) => (
            <div
              key={k.rank}
              className={`relative flex flex-col justify-between overflow-hidden rounded-3xl border p-6 md:p-7 ${
                i === 0
                  ? 'border-primary-200 bg-primary-100/60'
                  : i === 1
                  ? 'border-accent-200 bg-accent-100/50'
                  : 'border-secondary-200 bg-secondary-100/50'
              }`}
            >
              <div>
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-2xl font-label text-xl font-extrabold ${
                      i === 0 ? 'bg-primary-500 text-background-50' : i === 1 ? 'bg-accent-500 text-background-50' : 'bg-secondary-500 text-background-50'
                    }`}
                  >
                    {k.rank}
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/80 px-3 py-1 text-xs font-semibold text-foreground-700">
                    <i className="ri-fire-line text-accent-600"></i>
                    热度 {k.heat}
                  </span>
                </div>
                <p className="mt-5 text-xs font-semibold uppercase tracking-wider text-foreground-600">
                  {k.cat} · {k.month}
                </p>
                <h3 className="mt-2 font-heading text-xl font-black leading-snug tracking-tight md:text-2xl">{k.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{k.summary}</p>
              </div>
              <div className="mt-6 flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-foreground-600">
                  <i className={`${i === 0 ? 'ri-trophy-line' : i === 1 ? 'ri-medal-line' : 'ri-award-line'} ${i === 0 ? 'text-primary-700' : i === 1 ? 'text-accent-600' : 'text-secondary-700'}`}></i>
                  {i === 0 ? '年度瓜王' : i === 1 ? '年度亚军' : '年度季军'}
                </span>
                <a href="#talk" className="ml-auto inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-700 hover:text-primary-800">
                  围观讨论 <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 overflow-hidden rounded-3xl border border-background-200 bg-background-50">
          {rest.map((k, idx) => (
            <div
              key={k.rank}
              className={`flex flex-col gap-3 px-6 py-5 transition-colors hover:bg-background-100 sm:flex-row sm:items-center sm:gap-5 md:px-7 ${
                idx !== rest.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span className="font-label text-lg font-bold text-background-400">{k.rank}</span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <h4 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">{k.title}</h4>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-800">{k.cat}</span>
                </div>
                <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{k.summary}</p>
              </div>
              <div className="flex items-center gap-4 sm:shrink-0 sm:flex-col sm:items-end sm:gap-1">
                <span className="text-xs font-semibold text-foreground-500">{k.month}</span>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-600">
                  <i className="ri-fire-line text-accent-600"></i>
                  {k.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}